import { render, staticRenderFns } from "./CreateRoleDialog.vue?vue&type=template&id=6e867506&scoped=true&"
import script from "./CreateRoleDialog.vue?vue&type=script&lang=js&"
export * from "./CreateRoleDialog.vue?vue&type=script&lang=js&"
import style0 from "./CreateRoleDialog.vue?vue&type=style&index=0&id=6e867506&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e867506",
  null
  
)

export default component.exports